/**
 * 新手指引步骤配置。
 * selector 支持逗号分隔的多个候选选择器（取第一个可见元素，适配桌面/移动端布局差异）；
 * selector 为空 → 居中欢迎气泡（无高亮）。
 * 指引键与后端 fantasy_guide_record.guide_key 对应：home=家 street=街道。
 */

// 家场景指引
export function buildHomeGuideSteps() {
  return [
    {
      title: '欢迎来到幻之大地！',
      content: '这里是你在这个世界的家。我是向导小幻，带你快速认识各个功能～\n点击「下一个」继续，随时可以点右上角 × 关闭指引。',
      selector: ''
    },
    {
      title: '系统公告',
      content: '系统更新与活动消息会发布在这里，点击橙色标题栏可展开收起。',
      selector: '.sysmsgdiv'
    },
    {
      title: '物品陈列柜',
      content: '家中的柜子，点击可以存取物品；右侧「家中物品查询」能搜索家里的一切道具。',
      selector: '.grounddiv'
    },
    {
      title: '用户行为',
      content: '「上街」去王都逛逛，「休息」恢复体力并清空疲劳，「道具整理」「职业面板」也都在这里。',
      selector: '#movesdiv'
    },
    {
      title: '功能按钮与新手任务',
      content: '详细资料、打开背包、任务列表、信箱、好友、存盘都在这里。\n新手任务会一步步引导你熟悉王都——跟着「任务列表」里的主线任务前进，就能获得丰厚奖励！',
      selector: '.func-group',
      // 移动端功能按钮在侧边抽屉里，讲解前先滑出抽屉（GuideOverlay 处理开关时机）
      openDrawer: true
    }
  ];
}

// 街道场景指引（taskTodoList：当前任务待办，用于动态任务文案；优先展示链任务 taskIsRand=0）
export function buildStreetGuideSteps(taskTodoList) {
  const todo = taskTodoList || [];
  let npcTip = '点击 NPC 头像可以交谈、接任务、买卖物品。';
  if (todo.length > 0) {
    const chainTodo = todo.find(t => Number(t.taskIsRand) === 0) || todo[0];
    npcTip += '\n你当前的任务：「' + chainTodo.taskName + '」——按任务目标推进，完成后找交付对象回任务即可。';
  } else {
    npcTip += '\n找到发布任务的 NPC，开始你的第一份委托吧。';
  }
  const steps = [
    {
      title: '欢迎来到王都！',
      content: '街道是幻之大地的主要舞台。跟着我逛一圈，马上就能上手～',
      selector: ''
    },
    {
      title: '当前位置',
      content: '这里显示你所在的地点名称与介绍。王都各处都有不同的设施与机遇。',
      selector: '.placediv'
    },
    {
      title: 'NPC 与任务',
      content: npcTip,
      selector: '.npcdiv'
    },
    {
      title: '地上的道具',
      content: '街道上会随机刷新道具，点击就能拾入背包。',
      selector: '.grounddiv'
    },
    {
      title: '罗盘移动',
      content: '点击罗盘上的方向即可在地图之间移动，探索整座王都吧。',
      selector: '.desktop-compass, .bar-center'
    },
    {
      title: '功能按钮',
      content: '打开背包、查看任务列表（随时掌握任务目标与交付对象）、收发信件、存盘退出。',
      selector: '.func-group',
      // 同上：移动端先滑出侧边抽屉再讲解，走完这步自动收回
      openDrawer: true
    },
    {
      title: '特殊事件与商店',
      content: '商店、银行、钓鱼码头等设施入口都集中在「特殊事件」栏里，多多探索会有意外收获！',
      selector: '.event'
    }
  ];
  // 右下角快捷按钮：仅移动端展示（PC 端该区域已隐藏，用左栏入口）
  if (window.innerWidth <= 768) {
    steps.push({
      title: '常用功能快捷按钮',
      content: '地图、背包、任务一键直达，不用再翻开菜单找，在哪里都能看到它。',
      selector: '.street-quickbar'
    });
  }
  // 音乐盒：全端可拖动 + 位置记忆
  steps.push({
    title: '会跟着你的音乐盒',
    content: '右下角的小方块是音乐盒，点开就能听歌。按住它可以拖到屏幕任意位置，位置会自动记住，下次进来还停在你放的地方。',
    selector: '#aplayer .aplayer-body'
  });
  return steps;
}
